import { render, staticRenderFns } from "./mapBg.vue?vue&type=template&id=2f6e5f0b&scoped=true"
import script from "./mapBg.vue?vue&type=script&lang=js"
export * from "./mapBg.vue?vue&type=script&lang=js"
import style0 from "./mapBg.vue?vue&type=style&index=0&id=2f6e5f0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6e5f0b",
  null
  
)

export default component.exports